import BaseModal from "views/uikit/VLModal/BaseModal";
import VLButton from "views/uikit/Buttons/VLButton";
import styles from "./style.module.scss";

export type ShareActionType = "delete" | "updateRole";

export type ShareActionModalProps = {
  isOpen: boolean;
  close: () => void;
  currentRole?: string;
  newRole?: string;
  actionType?: ShareActionType;
  onConfirm: () => void | Promise<void>;
  loading?: boolean;
  datasetName: string;
};

export const ShareActionModal = ({
  isOpen,
  close,
  currentRole,
  newRole,
  actionType,
  onConfirm,
  loading,
  datasetName,
}: ShareActionModalProps) => {
  const handleConfirm = async () => {
    await onConfirm();
    close();
  };

  const getModalConfig = () => {
    if (actionType === "delete") {
      return {
        variant: "error" as const,
        title: "Remove Access",
        content: `Are you sure you want to remove this user’s access to Dataset ${datasetName}?`,
        actionText: "Remove",
      };
    }

    if (actionType === "updateRole") {
      return {
        variant: "info" as const,
        title: "Update Role",
        content: `Are you sure you want to change the role from ${currentRole} to ${newRole}?`,
        actionText: "Update",
      };
    }

    return {
      variant: "general" as const,
      title: "",
      content: "",
      actionText: "OK",
    };
  };

  const modalConfig = getModalConfig();

  const footer = (
    <div className={styles.footer}>
      <VLButton
        type="default"
        text="Cancel"
        onClick={close}
        disabled={loading}
      />
      <VLButton
        type="primary"
        text={modalConfig.actionText}
        onClick={handleConfirm}
        loading={loading}
        disabled={loading}
      />
    </div>
  );

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={close}
      variant={modalConfig.variant}
      headers={{
        title: modalConfig.title,
      }}
      footer={footer}
      size="default"
    >
      <div className={styles.modalContent}>{modalConfig.content}</div>
    </BaseModal>
  );
};
